import { BaseModel } from "model/BaseModel";
import Perfil from "./Perfil";
import Setor from "model/administracao/cadastro/Setor";
import Horario from "model/gestao/atividades/Horario";
import Pessoa from "./Pessoa";
import UsuarioSetor from "./UsuarioSetor";

export default class Usuario implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    senha: string;
    email: string;
    ativo: boolean;
    auditor: boolean;
    tecnico: boolean;
    perfis: Array<Perfil>;
    usuarioSetores: UsuarioSetor[];
    horario: Horario;
    notificacaoHorario: boolean;
    tipoDocumento: string;
    numeroDocumento: string;
    emailDrive: string;
    condutor: boolean;
    pessoa: Pessoa|null;

    constructor(
        id = 0, 
        codigo = null,
        nome = '',
        senha = '',
        email = '',
        ativo = true,
        auditor = false,
        tecnico = false,
        perfis = new Array<Perfil>(),
        usuarioSetores = new Array<UsuarioSetor>(),
        horario = new Horario(),
        notificacaoHorario = false,
        tipoDocumento = '',
        numeroDocumento = '',
        emailDrive = '',
        condutor = false,
        pessoa = null
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.senha = senha;
        this.email = email;
        this.ativo = ativo;
        this.auditor = auditor;
        this.tecnico = tecnico;
        this.perfis = perfis;
        this.usuarioSetores = usuarioSetores;
        this.horario = horario;
        this.notificacaoHorario = notificacaoHorario;
        this.tipoDocumento = tipoDocumento;
        this.numeroDocumento = numeroDocumento;
        this.emailDrive = emailDrive;
        this.condutor = condutor;
        this.pessoa = pessoa;
    }
}
